import React from "react"
import PropTypes from "prop-types"
import { get } from "../../helpers/utils"
import Link from "../UI/Link/Link"
import * as styles from "./NavigationItem-tw-styles"

const NavigationItem = props => {
  const { dropdownItemsCollection, link, variant } = props
  const mainLinks = get(dropdownItemsCollection, "items", [])
  const style = styles[variant] || styles.defaultStyle
  return (
    <div className={style?.mainContent}>
      <div className={style?.LinkContent}>
        <div className={style?.LinkContentTwo}>
          {link?.url && (
            <Link className={style?.Home} {...link}>
              {link?.label}
            </Link>
          )}
          {mainLinks && (
            <div className={style?.LinkContent}>
              <ul className={style?.LinkContentTwo}>
                {mainLinks?.map((item, index) => (
                  <li key={index}>
                    {
                      <Link className={style?.LinkTwo} {...item?.link}>
                        {item?.label}
                      </Link>
                    }
                    {item?.dropdownItemsCollection?.items.length > 0 && (
                      <div className={style?.LinkContent}>
                        <ul className={style?.LinkContentTwo}>
                          {item?.dropdownItemsCollection?.items?.map(
                            (link, idx) => (
                              <React.Fragment key={idx}>
                                <li>
                                  <Link
                                    className={style?.LinkThree}
                                    {...link?.link}
                                  >
                                    {link?.label}
                                  </Link>
                                </li>
                                {link?.subLinksCollection?.items?.length >
                                  0 && (
                                  <>
                                    <div className={style?.LinkContent}>
                                      <ul className={style?.LinkContentTwo}>
                                        {link?.subLinksCollection?.items?.map(
                                          (subLink, linkIndex) => (
                                            <>
                                              <li key={linkIndex}>
                                                <Link
                                                  className={style?.LinkThree}
                                                  {...subLink?.link}
                                                >
                                                  {subLink?.title}
                                                </Link>
                                              </li>
                                            </>
                                          )
                                        )}
                                      </ul>
                                    </div>
                                  </>
                                )}
                              </React.Fragment>
                            )
                          )}
                        </ul>
                      </div>
                    )}
                  </li>
                ))}{" "}
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

NavigationItem.propTypes = {
  dropdownItemsCollection: PropTypes.any,
  link: PropTypes.any,
  variant: PropTypes.string,
}

export default NavigationItem
